import { render, staticRenderFns } from "./LearningSettingsReminderUpdate.vue?vue&type=template&id=5f88589c&scoped=true&"
import script from "./LearningSettingsReminderUpdate.vue?vue&type=script&lang=js&"
export * from "./LearningSettingsReminderUpdate.vue?vue&type=script&lang=js&"
import style0 from "./LearningSettingsReminderUpdate.vue?vue&type=style&index=0&id=5f88589c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88589c",
  null
  
)

export default component.exports